import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SignIn } from '@clerk/react'
import { useAuth } from '@/contexts/AuthContext'
import { AuthLayout } from '@/components/branding/AuthLayout'
import { clerkAppearance } from '@/components/branding/clerkAppearance'

export function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      const returnPath = sessionStorage.getItem('returnPath') ?? '/'
      sessionStorage.removeItem('returnPath')
      navigate(returnPath, { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    )
  }

  return (
    <AuthLayout
      formTitle="Welcome back"
      formSubtitle="Sign in to continue protecting your web pages."
      switchPrompt="Don't have an account?"
      switchLinkText="Start free"
      switchLinkHref="/signup"
    >
      <SignIn
        signUpUrl="/signup"
        fallbackRedirectUrl="/"
        appearance={clerkAppearance}
      />
    </AuthLayout>
  )
}
